import { getGlobalParam } from '@agilemd/ui-utils';

const BASE_URL = getGlobalParam('baseUrl', '');
const JWT_TOKEN = getGlobalParam('sessionJsonWebToken', null);

// [KE] adds both the express mount point and, if available, jwt signature;
function getUrl(pathQeury, opts) {
  const options = opts || {};

  let out = (options.excludeBaseUrl ? '' : BASE_URL) + pathQeury;

  if (JWT_TOKEN) {
    if (out.indexOf('?') > -1) {
      out += '&';
    } else {
      out += '?';
    }

    out = `${out}jwt=${JWT_TOKEN}`;
  }

  return out;
}

export default getUrl;
